import { DEFAULT_NUMBER_LOCALE } from './number'

/* Decimal, not binary: `Intl` prints SI symbols, so dividing by 1024 would misstate the size. */
const KILOBYTE = 1000
const MEGABYTE = KILOBYTE * 1000

const byteFormatterCache = new Map<string, Intl.NumberFormat>()

function byteFormatterFor(locale: string, unit: string, maximumFractionDigits: number) {
  const key = `${locale}:${unit}:${maximumFractionDigits}`
  let formatter = byteFormatterCache.get(key)
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'unit',
      unit,
      unitDisplay: 'short',
      maximumFractionDigits,
    })
    byteFormatterCache.set(key, formatter)
  }
  return formatter
}

/** Renders a byte count at the largest readable unit in `locale`; the unit symbol comes from `Intl`, not a catalogue. */
export function formatFileSize(bytes: number, locale: string = DEFAULT_NUMBER_LOCALE): string {
  if (bytes >= MEGABYTE) return byteFormatterFor(locale, 'megabyte', 1).format(bytes / MEGABYTE)
  // The floor is the kilobyte: CLDR's short byte form is the singular.
  return byteFormatterFor(locale, 'kilobyte', 1).format(bytes / KILOBYTE)
}
